module.exports = __webpack_public_path__ + "img/logo.0f8d36aa.png";